import { CollectionViewItemProps } from './CollectionViewItem';

export const AUDIO_COLLECTION_ITEMS: CollectionViewItemProps[] = [
    {
        thumbnailUrl:
            'https://d2h53m62qt2m27.cloudfront.net/collection_pages/AB/ziykjrd0lojv1xbnta6q-1564669914947.jpg',
        name: 'Travel',
        url: '/audio/collections/travel-video',
    },
    {
        thumbnailUrl:
            'https://d2h53m62qt2m27.cloudfront.net/collection_pages/AB/tiiwrflgyojfnpzzoakg-1571068693948.jpg',
        name: 'Music for Explainer Videos',
        url: '/audio/collections/music-for-explainer-videos',
    },
    {
        thumbnailUrl:
            'https://d2h53m62qt2m27.cloudfront.net/collection_pages/AB/rm1eyudrxk3div1iflzc-1564674911761.jpg',
        name: 'Explainer Video',
        url: '/audio/collections/explainer-video',
    },
    {
        thumbnailUrl:
            'https://d2h53m62qt2m27.cloudfront.net/collection_pages/AB/r6gr3jgdp17fnmkg6lh5-1564674312903.jpg',
        name: 'Sports and Fitness',
        url: '/audio/collections/sports-and-fitness-video',
    },
];

export const IMAGE_COLLECTION_ITEMS: CollectionViewItemProps[] = [
    {
        thumbnailUrl:
            'https://d1ow200m9i3wyh.cloudfront.net/collections//tmp/7037b43905f01717284cf96591f35d3877d8610f3a1cdde3e817a6bca5a714fa_dir.jpg',
        name: 'Infographic Templates',
        url: '/images/collections/infographic-templates',
    },
    {
        thumbnailUrl:
            'https://d1ow200m9i3wyh.cloudfront.net/collections//tmp/bf22fd37710d51a307d6ff4f5613eb623fded37069465894d145cb3e98067f00_dir.jpg',
        name: 'Event Poster Templates',
        url: '/images/collections/event-poster-templates',
    },
    {
        thumbnailUrl:
            'https://d1ow200m9i3wyh.cloudfront.net/collections//tmp/61f9475eb5711ede21badc4bfd7bc9e4510501036325a81046654126c9968401_dir.png',
        name: 'Mockup Templates',
        url: '/images/collections/design-psd-mockups',
    },
    {
        thumbnailUrl:
            'https://d1ow200m9i3wyh.cloudfront.net/collections//tmp/e17512b30ddac3b68783394d26f84098075816ea4bd2963a6a630d5b129127dd_dir.jpg',
        name: 'Creative Backgrounds',
        url: '/images/collections/background-images',
    },
    {
        thumbnailUrl:
            'https://d1ow200m9i3wyh.cloudfront.net/collections//tmp/ba9e51b2136427848e335a35c3b1175e0d271e077ec2b711b65f951191e98a68_dir.jpg',
        name: 'Infographic Icons',
        url: '/images/collections/infographic-vector-icons',
    },
    {
        thumbnailUrl:
            'https://d1ow200m9i3wyh.cloudfront.net/collections//tmp/a6c5a8ba1fb117770e3a1eb6ed9cd23eec266d1467f450da9e1a57e25e4b691f_dir.jpg',
        name: 'Creative Edge',
        url: '/images/collections/creative-edge-colorful-images',
    },
    {
        thumbnailUrl:
            'https://d1ow200m9i3wyh.cloudfront.net/collections//tmp/b5223beec0dc4667be96f25eb7d79764aba393634e251d86496846143e2e2da1_dir.jpg',
        name: 'The Future of Creativity',
        url: '/images/collections/future-of-creativity',
    },
    {
        thumbnailUrl:
            'https://d1ow200m9i3wyh.cloudfront.net/collections//tmp/61a4ef6170c3987bdfef7c619d395a77193f9d4f2bed4d85846d94c49566187f_dir.jpg',
        name: 'Get Cozy',
        url: '/images/collections/cozy-photos',
    },
];

export const VIDEO_COLLECTION_ITEMS: CollectionViewItemProps[] = [
    {
        thumbnailUrl: 'https://d3g7htsbjjywiv.cloudfront.net/assets/common/images/collections/bio-video-monica.png',
        name: 'Re:Stock - Diverse Stock Footage',
        url: '/diverse-stock-footage',
    },
    {
        thumbnailUrl: 'https://d2h53m62qt2m27.cloudfront.net/collection_pages/VB/nat-doc-directory.jpg',
        name: 'Nature Documentary',
        url: '/video/collections/nature-documentary-footage',
    },
    {
        thumbnailUrl:
            'https://d1ow200m9i3wyh.cloudfront.net/collections//tmp/77e7be521fe2d361cd2e5ca530645bbcfba1a89cb9b04d28ddefd968cb24e777_dir.jpg',
        name: 'Space Exploration',
        url: '/video/collections/space-footage-exploration',
    },
    {
        thumbnailUrl: 'https://d2h53m62qt2m27.cloudfront.net/collection_pages/VB/aerials_thumb.jpg',
        name: 'Amazing Aerials',
        url: '/video/collections/premium-aerial-footage',
    },
    {
        thumbnailUrl:
            'https://d1ow200m9i3wyh.cloudfront.net/collections//tmp/21a22701fff5588a46538be78c438f193e5c0a339575c78d01380bdbaf24c2cf_dir.png',
        name: 'YouTube Templates',
        url: '/video/collections/youtube-intros-outros',
    },
    {
        thumbnailUrl:
            'https://d1ow200m9i3wyh.cloudfront.net/collections//tmp/add71fbc87e813b815bbb8e9ea88ce67600b65670713917b4ecbdfc7eec2c0a9_dir.jpg',
        name: 'Landmark Footage',
        url: '/video/collections/landmark-footage',
    },
    {
        thumbnailUrl: 'https://d2h53m62qt2m27.cloudfront.net/collection_pages/VB/timewarp-vb-directory.jpg',
        name: 'Timewarp Footage',
        url: '/video/collections/timewarp-footage',
    },
    {
        thumbnailUrl:
            'https://d1ow200m9i3wyh.cloudfront.net/collections//tmp/2bb09ac82effaf16a9c72dda9fe04c34a7aec6ce319965a4846dbfdeb75b93a1_dir.jpg',
        name: 'Creator to Creator',
        url: '/video/collections/creator-to-creator',
    },
];
